import FiltersActive from "@/components/molecules/FiltersActive/FiltersActive";
import SmallPlayer from "@/components/molecules/Player/FC24/SmallPlayer";
import MobileHeaderBar from "@/components/organisms/SbcSetHeaderBar/MobileHeaderBar";
import {
  roundGreenCheckmarkIcon,
  roundRedMinusIcon,
} from "@/designSystemIcons";
import { SearchedPlayer } from "@/redux/players/SearchedPlayer.type";

const IncludedExcludedPlayers = ({
  isOpen,
  onClose,
  players,
  excludedPlayers,
  onPlayerClick,
  isMobile,
  type,
}: {
  isOpen: boolean;
  onClose: () => void;
  players: SearchedPlayer[];
  excludedPlayers: SearchedPlayer[];
  onPlayerClick: (resourceId: number) => void;
  isMobile: boolean;
  type: "include" | "exclude" | null;
}) => {
  if (!isOpen || !isMobile) return null;

  const title =
    type === "include" ? (
      <div className="flex flex-row items-center gap-2">
        Must Include Players <span>{roundGreenCheckmarkIcon}</span>
      </div>
    ) : (
      <div className="flex flex-row items-center gap-2">
        Exclude Players <span>{roundRedMinusIcon}</span>
      </div>
    );

  const activePlayers = type === "include" ? players : excludedPlayers;

  return (
    <div className="fixed inset-0 z-50 bg-panel-background flex flex-col">
      <MobileHeaderBar
        showFiltersBar={true}
        setShowFiltersBar={onClose}
        filtersTitle={title}
        showCloseIcon={true}
      />

      <div className="h-14 flex items-center bg-panel-middleground">
        <FiltersActive renderHorizontally={true} />
      </div>

      <div className="flex-1 overflow-y-auto bg-panel-middleground m-4 rounded-lg flex flex-col justify-between">
        <div className="grid grid-cols-3 gap-3 p-4 items-start">
          {activePlayers.map((player) => (
            <button
              key={player.resourceId}
              onClick={() => onPlayerClick(player.resourceId)}
              className="flex justify-center items-center h-fit"
            >
              <div className="flex items-center">
                <SmallPlayer {...player} isOnIncludeExcludeSection />
              </div>
            </button>
          ))}
        </div>
        <div className="w-full flex justify-end p-2">
          <button className="h-[32px] w-[90px] bg-[#49535F] rounded">
            Add +
          </button>
        </div>
      </div>
    </div>
  );
};

export default IncludedExcludedPlayers;
